import { ColDef, GridOptions } from 'ag-grid-community'
import { AliasDetail, WorkflowDetail } from 'api'
import { Locale, Translation } from 'locale'
import { createActionsRenderer, gridOptionsBase, TypedValueGetterParams } from 'view/components/datagrid'
import { TradingEntityAliasesPanelActionsButton } from './TradingEntityAliasesPanelActionsButton'

export enum TradingEntityAliasesPanelGridColumnId {
  ACTIONS = 'TRADING_ENTITY_ALIAS_PANEL_ACTIONS',
  MY_ENTITY = 'TRADING_ENTITY_ALIAS_PANEL_MY_ENTITY',
  COUNTERPARTY_NAME = 'TRADING_ENTITY_ALIAS_PANEL_COUNTERPARTY',
  ALIAS_NAME = 'TRADING_ENTITY_ALIAS_PANEL_ALIAS_NAME',
  ALIAS_TYPE = 'TRADING_ENTITY_ALIAS_PANEL_ALIAS_TYPE'
}

export const tradingEntityAliasesPanelGridOptions: GridOptions<WorkflowDetail<AliasDetail>> = {
  ...gridOptionsBase,
  getRowId: ({ data }) => data.id
}

export const tradingEntityAliasesPanelColumnDefs: ColDef[] = [
  {
    colId: TradingEntityAliasesPanelGridColumnId.ACTIONS,
    headerName: Locale.translate(Translation.TC_EMPTY_HEADER),
    equals: () => false,
    width: 150,
    cellRenderer: createActionsRenderer(TradingEntityAliasesPanelActionsButton),
    cellClass: 'action-cell',
    pinned: 'left',
    lockPinned: true,
    lockPosition: true,
    lockVisible: true,
    enableRowGroup: false,
    filter: false,
    sortable: false
  },
  {
    colId: TradingEntityAliasesPanelGridColumnId.MY_ENTITY,
    valueGetter: (params: TypedValueGetterParams<WorkflowDetail<AliasDetail>>) =>
      params.data?.ownerTradingEntity && params.data.ownerTradingEntity.publishedName,
    headerName: Locale.translate(Translation.TC_MY_ENTITY),
    width: 150,
    filter: 'agSetColumnFilter',
    lockVisible: true
  },
  {
    colId: TradingEntityAliasesPanelGridColumnId.COUNTERPARTY_NAME,
    valueGetter: (params: TypedValueGetterParams<WorkflowDetail<AliasDetail>>) =>
      params.data?.subjectTradingEntity && params.data.subjectTradingEntity.publishedName,
    headerName: 'Counterparty Name',
    width: 150,
    filter: 'agSetColumnFilter',
    lockVisible: true
  },
  {
    colId: TradingEntityAliasesPanelGridColumnId.ALIAS_TYPE,
    valueGetter: (params: TypedValueGetterParams<WorkflowDetail<AliasDetail>>) =>
      params.data?.aliasTypeAndValue && params.data.aliasTypeAndValue.type,
    headerName: 'Alias Type',
    width: 100,
    filter: 'agSetColumnFilter',
    lockVisible: true
  },
  {
    colId: TradingEntityAliasesPanelGridColumnId.ALIAS_NAME,
    valueGetter: (params: TypedValueGetterParams<WorkflowDetail<AliasDetail>>) =>
      params.data?.aliasTypeAndValue && params.data.aliasTypeAndValue.value,
    headerName: 'Alias Name',
    width: 150,
    filter: 'agSetColumnFilter'
  }
]
